import clsx from 'clsx';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const useStyles = makeStyles(() => ({
  root: {
    verticalAlign: 'middle',
    lineHeight: '24px',
    display: 'flex',
  },
  icon: {
    verticalAlign: 'top',
    cursor: 'pointer',
    marginLeft: 4,
  },
}));

const ToggleValue = props => {
  const classes = useStyles();
  const { value, hide = v => v } = props;
  const { className } = props;
  const [visible, show] = useState(false);

  const options = {
    className: clsx('cncui-value', classes.root, className),
  };

  return (
    <span {...options}>
      {visible ? value : hide(value)}
      {visible ? (
        <Visibility className={classes.icon} onClick={() => show(false)} />
      ) : (
        <VisibilityOff className={classes.icon} onClick={() => show(true)} />
      )}
    </span>
  );
};

export default ToggleValue;
